import React from 'react';
import { createRoot } from 'react-dom/client';
import markerSDK from '@marker.io/browser';
import config from './config';
import './utils/dayjs'; // register dayjs plugins before any consumer imports
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (config.MARKER_PROJECT_ID) {
  markerSDK.loadWidget({
    project: config.MARKER_PROJECT_ID,
    customData: {
      currentSHA: config.LATEST_SHA
    }
  })
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
